/**
 * Bootstrap 5 Tooltip Compatibility Shim for jQuery-QueryBuilder
 * 
 * jQuery-QueryBuilder's bt-tooltip-errors plugin expects Bootstrap 4's API structure:
 * - $.fn.tooltip.Constructor
 * - $.fn.tooltip.Constructor.prototype.fixTitle
 * 
 * Bootstrap 5 uses a different structure, so this shim provides the expected API.
 */
(function($) {
    'use strict';
    
    // Wait for both jQuery and Bootstrap to be loaded
    if (typeof $ === 'undefined' || typeof bootstrap === 'undefined') {
        console.warn('Bootstrap 5 Tooltip Shim: jQuery or Bootstrap not loaded yet');
        return;
    }
    
    // Only add shim if Bootstrap 5 tooltip exists but doesn't have the old API
    if ($.fn.tooltip && bootstrap.Tooltip) {
        // Get the Bootstrap 5 Tooltip class
        var Tooltip = bootstrap.Tooltip;
        
        // Add Constructor property to match Bootstrap 4 API
        if (!$.fn.tooltip.Constructor) {
            $.fn.tooltip.Constructor = Tooltip;
            
            // Add fixTitle method if it doesn't exist
            // This method is used by Bootstrap 4 to handle title attributes
            if (!Tooltip.prototype.fixTitle) {
                Tooltip.prototype.fixTitle = function() {
                    // Bootstrap 5 uses _getTitle() method
                    if (typeof this._getTitle === 'function') {
                        var title = this._getTitle();
                        if (title) {
                            // Bootstrap 5 uses data-bs-original-title
                            this._element.setAttribute('data-bs-original-title', title);
                            this._element.setAttribute('title', '');
                        }
                    }
                };
            }
        }
    } else {
        console.warn('Bootstrap 5 Tooltip Shim: $.fn.tooltip or bootstrap.Tooltip not found');
    }
})(typeof jQuery !== 'undefined' ? jQuery : typeof $ !== 'undefined' ? $ : null);
